
































import 'reflect-metadata'
import { Vue, Component, Watch } from 'vue-property-decorator'
import api from '@/axios'
import ResultRow from '@/components/Search/ResultRow.vue'
import Loader from '@/components/misc/Loader.vue'

@Component({
    components: {
        Loader,
        ResultRow,
    },
})
export default class Search extends Vue {
    loading = false
    query: string | (string | null)[] = ''
    results: any[] = []

    created() {
        this.query = this.$router.currentRoute.query.query
        if (this.query) {
            this.search()
        }
    }

    @Watch('$route')
    onRouteChanged(val: any) {
        this.results = []
        this.query = val.query.query
        this.search()
    }

    search() {
        this.loading = true
        // TODO: support service for multiple chains
        const chain = this.$router.currentRoute.query.chain

        if (chain !== 'ACT') {
            api.get('/ast/search?query=' + this.query).then((res) => {
                this.loading = false
                const data = res.data
                this.results = data === null ? [] : data.results
            })
        } else {
            const filter = this.$router.currentRoute.query.filter
            this.loading = false
            this.results = []
        }
    }
}
